module.exports = __webpack_public_path__ + "static/media/14.52df0194.jpg";